import { useEffect, useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { changeThemeSetting, removeThemeSetting } from 'foundations-theming/utils/themeSwitcher';
export const useSyncTrellisTheme = () => {
  const gates = useAppSelector(selectGates);
  const isTrellisGated = useMemo(() => {
    return gates && gates.length > 0 && !gates.includes('trellis:primary');
  }, [gates]);
  const isTrellisAlwaysOnUngated = useMemo(() => {
    return gates && gates.includes('trellis:always-on');
  }, [gates]);
  useEffect(() => {
    // If the user is always on trellis, turn on the trellis theme if it was
    // somehow turned off
    if (isTrellisAlwaysOnUngated) {
      changeThemeSetting('trellis', 'light');
    } else if (isTrellisGated) {
      // If the user is gated, turn off the trellis theme unless they are always
      // on trellis
      removeThemeSetting();
    }
  }, [isTrellisGated, isTrellisAlwaysOnUngated]);
};